// extracted by mini-css-extract-plugin
export default {"scrollContainer":"styles_scrollContainer__if9Qc"};